<template>
<div class="container">
  <div v-show="!resultVisible" class="jh1">
    <div class="jh2">
      <div class="jh2-1">
        <h4>温馨提示</h4>
        <p>请认真填写物流信息，方便商家接收换货商品</p>
      </div>
      <div class="jh2-2">
        <h4>邮寄地址信息</h4>
        <p>请按照如下信息邮寄商品给商家</p>
        <p>收件人：{{option.returnUserName}}</p>
        <p>手机号：{{option.returnMobile}}</p>
        <p>换货地址：{{option.address}}</p>
        <p>换货说明：{{option.changeProductRemark}}</p>
      </div>
    </div>
    <div class="jh3">
      <div class="title">物流信息</div>
      <van-field @focus="isFixShow = false" @blur="isFixShow = true" placeholder="请输入" v-model="companyName" label="物流公司" input-align="right" />
      <van-field @focus="isFixShow = false" @blur="isFixShow = true" maxlength="18" v-model="wcode" label="物流单号" input-align="right" placeholder="请输入"/>
    </div>
    <!-- :class="isFixShow ? 'fix' : 'stc'" -->
    <div class="navbar-fixed fix" >
      <van-button :disabled="option.editor == 'add' && option.status !== 'USER_SEND_GOODS_ING'" :loading="loading" @click="checkFun" class="btn">{{option.editor == 'editor' ? '修改换货物流信息': (radioFormat[option.afterSaleType] || '提交')}}</van-button>
    </div>
  </div> 
  <div v-show="resultVisible" class="jhr">
    <div class="jhr1">
      <van-image
        width="100"
        height="100"
        fit="cover"
        :src="pdownIncon"
      />
      <p class="p">物流信息提交成功</p>
      <div class="btn" @click.once="$router.back();">返回</div>
    </div>
  </div>
</div>
</template>
<script>
import http from "@/utils/axios";

export default {
  data() {
    return {
      option:{},
      companyName:'',
      wcode:'',
      loading: false,
      radioFormat:{
        'JUST_PRODUCT': '提交退货退款物流信息',
        'JUST_MONEY': '提交退货物流信息',
        'CHANGE_PRODUCT': '提交换货物流信息',
      },
      resultVisible: false,
      pdownIncon: require("@/assets/atlas/mi2.png"),
      isFixShow: true
    };
  },
  methods: {
    checkFun(){
      if(!this.companyName.replace(/\s/g,"")){
        this.$toast('请输入物流公司')
        return
      }
      if(!this.wcode.replace(/\s/g,"")){
        this.$toast('请输入物流单号')
        return
      }
      this.loading = true
      this.doSubmit()
    },
    doSubmit(){
      let url = this.option.editor == 'editor' ? 'order/app/newafter/updateExpress' : 'order/app/newafter/sendGoods'
      let parm={
        afterId: this.option.afterId,
        expressCompany: this.companyName,
        expressNo: this.wcode
      }
      http({
        url: url,
        method: "post",
        parmes: parm
      }).then(rps => {
        this.loading = false;
        this.resultVisible = true
      })
    },
  },
  created() {
    this.$loading.hide()
    this.option = this.$store.state.userAfterSaleSureAddressObj || {}
    if(this.option.editor == 'editor'){
      this.companyName = this.option.expressCompany
      this.wcode = this.option.expressNo
    }
  },
  components: {
    
  }
};
</script>
<style lang="less" scoped >
.container {
  min-height: 100vh;
  box-sizing: border-box;
  padding-bottom: 120px;
}
.jh1{
  background: #F7F7F7;
  padding-top: 10px;
  .jh2{
    padding-left: 30px;
    padding-right: 30px;
    padding-top: 30px;
    background: #ffffff;
    .jh2-1{
      height: 120px;
      background: #F7F7F7;
      border-radius: 20px;
      padding-left: 30px;
      padding-top: 20px;
      h4{
        color: #333333;
        font-size: 26px;
        margin-bottom: 10px;
      }
      p{
        color: #999999;
        font-size: 24px;
      }
    }
    .jh2-2{
      padding-left: 30px;
      padding-top: 30px;
      padding-bottom: 54px;
      h4{
        color: #333333;
        font-size: 26px;
        margin-bottom: 25px;
      }
      p{
        color: #999999;
        font-size: 24px;
        margin-bottom: 5px;
      }
    }
  }
  .jh3{
    margin-top: 10px;
    padding-top: 28px;
    padding-left: 40px;
    padding-bottom: 20px;
    background: #ffffff;
    .title{
      color: #333333;
      font-size: 28px;
      margin-bottom: 40px;
    }
    .van-cell {
      padding-left: 0;
    }
  }
  .navbar-fixed {
    width: 100%;
    left: 0;
    bottom: 0;
    background: #fff;
    display: flex;
    justify-content:center;
    z-index: 3;
    border-top: 1PX solid #fafafa;
  }
  .fix{
    position: fixed;
  }
  .stc{
    position: static;
  }
  .btn{
    width: 600px;
    height: 80px;
    line-height: 80px;
    background: var(--buttonColor);
    border-radius: 44px;
    color: var(--textColor);
    font-size: 26px;
    text-align: center;
    margin-top: 10px;
    margin-bottom: 10px;
    border: 0px;
  }
}
.jhr{
  background: #F7F7F7;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
  .jhr1{
    min-height: 1055px;
    background: #FFFFFF;
    border-radius: 20px;
    text-align: center;
    padding-top: 120px;
    .p{
      margin-top: 20px;
      font-size: 28px;
      margin-bottom: 60px;
    }
    .btn{
      width: 240px;
      line-height: 64px;;
      background: var(--buttonColor);
      border-radius: 10px;
      height: 64px;
      color: var(--textColor);
      font-size: 24px;
      margin: 0 auto;
    }
  }
}
</style>